// extracted by mini-css-extract-plugin
export default {"password-form":"PasswordForm_password-form__mLlTN"};